<template>
  <section
    class="my-8 md:mb-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-0 font-helvetica text-[18px] md:text-[22px] font-semibold text-[#999999] shadow-black shadow-xl divide-y-2 divide-white max-w-[1400px]"
  >
    <RallyLogoDownload />
    <div class="py-8 mt-8">
      <h1 class="text-white font-russo text-3xl">
        CROSS COUNTRY RALLY ROADBOOKS
      </h1>
      <h2 class="">FIA Legal Roadbooks Direct to PDF or Digital</h2>
      <GuideDownloadCta />
      <EventsBanner :images="eventsBannerImages" />
    </div>
    <div class="py-8 flex flex-col gap-4">
      <YouTubeEmbed
        style="border: 4px solid #999999"
        class="m-auto w-[300px] h-[182px] md:w-[650px] md:h-[395px] lg:w-[896px] lg:h-[448px]"
        title="Rally Navigator Cross Country Rally video playlist"
        src="https://www.youtube.com/embed/videoseries?list=PLNm8k_Nu19WA"
        thumb="https://i.ytimg.com/vi/H5IWI_zsBG8/maxresdefault.jpg"
      />
      <h2>Powered by MapBox and GPS</h2>
      <h2>Detailed GPX Tracks with Enhanced Route and Scoring Data</h2>
      <h2>
        Pro Users Can Upload Custom Navigation Icons and Custom Roadbook Header
        Images
      </h2>
      <picture class="contents">
        <source srcset="/images/create-cross-country/CC-Roadbook-Sample.webp" type="image/webp" />
        <img
        decoding="async"
        width="673"
        height="671"
        src="/images/create-cross-country/CC-Roadbook-Sample.png"
        class="flex m-auto"
        alt="Sample cross-country rally roadbook page created in Rally Navigator"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <picture class="contents">
        <source srcset="/images/create-cross-country/capture_decran_2022-01-04_152150-1-300x117.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="300"
        height="117"
        src="/images/create-cross-country/capture_decran_2022-01-04_152150-1-300x117.png"
        class="flex m-auto"
        alt="FIA World Rally-Raid Championship logo"
        />
      </picture>
      <p
        class="font-russo text-[26px] font-medium text-[#FF0000] hover:underline"
      >
        <router-link to="/fim-fia-roadbook-specs-rules">
          FIA WORLD RALLY RAID CHAMPIONSHIP
        </router-link>
      </p>
      <p
        class="font-russo text-[26px] font-medium text-[#FF0000] hover:underline"
      >
        <router-link to="fim-fia-roadbook-specs-rules">
          ROADBOOK REGULATIONS &#8211; CLICK FOR MORE INFO
        </router-link>
      </p>
      <YouTubeEmbed
        style="border: 4px solid #999999; margin-top: 24px"
        class="m-auto w-[300px] h-[182px] md:w-[650px] md:h-[395px] lg:w-[896px] lg:h-[448px]"
        title="How to Read a Dakar Rally Roadbook"
        src="https://www.youtube.com/embed/zDiXs-3-aZs?si=XaGZf8-Uy3vpR4Jp"
        thumb="https://i.ytimg.com/vi/zDiXs-3-aZs/maxresdefault.jpg"
      />
    </div>
    <div class="py-8 flex flex-col gap-4 text-left" @click="onSampleClick">
      <h2 class="font-russo text-[20px] font-semibold text-center">
        RALLY NAVIGATOR EXPORT AND PRINT SAMPLE FILES
      </h2>
      <SampleRoadbookIntro
        name="Cross Country"
        stats="24 km · 26 waypoints · 10-page A5 roadbook"
        description="Dakar-style rally-raid navigation: follow CAP headings across the dunes of Glamis to Basecamp 4, with tulips, FIA icons, danger levels, speed zones and notes."
        image="cross-country-roadbook-page"
        :image-width="638"
        :image-height="872"
        pdf-href="/create-cross-country/Cross_Country_Rally_Sample-A5.pdf"
        rn2-href="/create-cross-country/Cross_Country_Rally_Sample.rn2"
      />
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        RN2 File &#8211; Cross Country Sample Route
      </p>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample.rn2"
              download="Cross_Country_Rally_Sample.rn2"
              target="_blank"
            >
              Cross Country Rally Sample
            </a>
          </p>
        </li>
      </ul>
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        GPX, KML and KMZ Files &#8211; Cross Country Sample Route
      </p>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample.gpx"
              target="_blank"
            >
              GPX Route Cross Country Rally &#8211; Including OpenRally Scoring
              and Control Data
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Route.gpx"
              target="_blank"
            >
              GPX Route Cross Country Rally &#8211; Waypoints Only for GPS
              Devices and Mapping Tools
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample.kml"
              target="_blank"
            >
              KML Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample.kmz"
              target="_blank"
            >
              KMZ Cross Country Rally &#8211; Speed Zones, Neutralizations and
              Track Segments
            </a>
          </p>
        </li>
      </ul>
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        PDF File &#8211; Cross Country Roadbook
      </p>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-A4.pdf"
              target="_blank"
            >
              A4 &#8211; Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-A5.pdf"
              target="_blank"
            >
              A5 &#8211; Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Letter.pdf"
              target="_blank"
            >
              Letter &#8211; Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Legal.pdf"
              target="_blank"
            >
              Legal &#8211; Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Roll-x1.pdf"
              target="_blank"
            >
              Moto Style ROLL x 1 &#8211; Cross Country Rally
            </a>
          </p>
        </li>
      </ul>
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        <strong
          >Pro PDF File Options &#8211; Commercial Roll Print Ready</strong
        >
      </p>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Roll-x6.pdf"
              target="_blank"
            >
              Moto Style Roll x 6 &#8211; Cross Country Rally on 36&#8243; Paper
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-Roll-x8.pdf"
              target="_blank"
            >
              Moto Style Roll x 8 &#8211; Cross Country Rally on A0 Paper
            </a>
          </p>
        </li>
      </ul>
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        Time Speed Distance Worksheet
      </p>
      <ul class="text-left list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="create-cross-country/Cross_Country_Rally_Sample-TSD.xlsx"
              target="_blank"
            >
              Time Speed Distance Sheet &#8211; Cross Country Rally Sample
              (XLSX)
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <router-link to="/time-speed-distance">
              More Info Here
            </router-link>
          </p>
        </li>
      </ul>
      <p class="text-[#A9A9A9] font-arial text-[17px] font-bold">
        FIA Cross Country Rally Rules and Regulations
      </p>
      <ul class="text-left list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="https://www.fia.com/system/files/documents/260623_2026_cross-country_rally_sporting_regulations.pdf"
              rel="noopener"
              target="_blank"
            >
              FIA Cross Country Rally Rules and Roadbook Specifications
            </a>
          </p>
        </li>
      </ul>
      <router-link to="/timing-scoring">
        <h2
          class="text-[#FF0000] hover:underline font-helvetica text-[18px] md:text-[22px] font-bold text-center"
        >
          RALLY NAVIGATOR INTEGRATES WITH LEADING RALLY TRACKING SYSTEMS
        </h2>
      </router-link>
    </div>
    <div
      class="py-8 flex flex-col gap-4 font-helvetica text-[#999999] text-[18px] md:text-[22px]"
    >
      <h2 class="font-bold text-left">Choose Your Format</h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Start with File &gt; New Cross Country, or File &gt; New Cross Country
          FIA Dakar for the FIA layout with a wider tulip box and MODIF / NEW
          NOTE markers. The Dakar layout is available to every user.
        </li>
        <li>
          Changed your mind? Roadbook &gt; Change Roadbook Format converts a saved
          roadbook between Cross Country, Road Rally and FIA Dakar.
        </li>
      </ul>
      <h2 class="font-bold">Create a Roadbook by Drawing on the Map</h2>
      <h2 class="font-bold text-left">
        <b>Double Click the Map &amp; Create Your First Waypoint</b>
      </h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Enter Route Name, Description, Start and Finish Location in Header
        </li>
        <li>Click along route on Map to create Track Handles and red track.</li>
        <li>
          Double Click Track handle again to create all Waypoints along Route to
          Finish
        </li>
        <li>
          Carefully place 1st Track Handle after Waypoint to set direction of
          path leaving Waypoint, it&#8217;s used to automatically draw simple
          Tulip
        </li>
      </ul>
      <h2 class="font-bold text-left">
        Mapbox &#8211; Snap to Roads &#8211; See the Power of Rally Navigator
      </h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Snap to Roads. Rally Navigator will quickly trace roads shown on the
          Map
          <ul class="list-disc pl-8 text-left py-2 flex flex-col gap-2">
            <li>PC: Ctrl + Click Road on Map</li>
            <li>Mac: Cmd + Click Road on Map</li>
          </ul>
        </li>
        <li>
          Snap to Roads with Text Navigation Added to Each Waypoint
          <ul class="list-disc pl-8 text-left py-2 flex flex-col gap-2">
            <li>PC: Ctrl + Alt + Click Road on Map</li>
            <li>Mac: Cmd + Option + Click Road on Map</li>
          </ul>
        </li>
        <li>
          Or turn on Map &gt; Follow Roads and every click follows the road.
          Follow Roads works mid-route too.
        </li>
      </ul>
      <picture class="contents">
        <source srcset="/images/create-cross-country/CC-Screen-Shot-1.webp" type="image/webp" />
        <img
          decoding="async"
          loading="lazy"
          width="1919"
          height="1031"
          src="/images/create-cross-country/CC-Screen-Shot-1.jpg"
          class="flex m-auto"
          alt="Cross-country rally route and waypoints on the Rally Navigator map"
          sizes="(max-width: 1919px) 100vw, 1919px"
        />
      </picture>
      <h2 class="font-bold">Create a Roadbook from GPX, KML or KMZ Tracks</h2>
      <h3 class="text-white font-arial text-[16px]">
        Import GPX, KML or KMZ tracks. For best results, use a single continuous
        path. RiverNotes 2 and Tulip roadbooks import too.
      </h3>
      <h2 class="font-bold text-left">
        Import a GPX, KML or KMZ Track to Get Started
      </h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Select File &gt; Import &gt; Import GPX/KML/KMZ File. Choose your
          roadbook format, then pick the import options: Remove Timestamps,
          Remove Extra Track Points, and Include Waypoints to turn the
          file&#8217;s waypoints into roadbook waypoints.
        </li>
        <li>You will see imported Tracks projected onto Main Map Screen.</li>
        <li>
          Big GPS recordings are simplified automatically on import, so the app
          stays fast. Clean up a track any time with File &gt; Remove Extra
          Track Points &#8211; it shows the points you have now, the points
          you&#8217;ll keep and the reduction before it runs.
        </li>
        <li>
          You can Insert Additional Tracks at the Start or End of the Track
          using File, Insert Track
        </li>
        <li>
          Enter Route Name, Description, Start and Finish Location in Header
        </li>
      </ul>
      <h2 class="font-bold text-left">
        Fine Tune Track and Create Waypoints Along the Route
      </h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Mouse over the red Track and Click to create a track handle. Place
          handle carefully along track on Map to align track along your intended
          route. The Track is used to measure distance and must be accurate.
        </li>
        <li>
          Double Click a Track Handle to create a Waypoint at each intersection
          or POI along the route. Rally Navigator will automatically capture
          segment and total distance, generate tulip, GPS coordinates.
        </li>
        <li>
          Select the Road Type of the Main Tulip Arrow by clicking on Tulip road
          and then clicking on desired road type in the drawing tools bar.
          Changing a road type with change subsequent tulips also.
        </li>
      </ul>
      <h2 class="font-bold text-left">
        Add Waypoint Details: Roads, Icons Text
      </h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>Select a Waypoint by clicking in Roadbook.</li>
        <li>
          Drag desired &#8220;no go&#8221; road segments into Waypoint editor
          and shape road to create tulip, so curves in road and angles of roads
          at intersection exactly match.
        </li>
        <li>
          Drag and drop proper Navigation icons and signs into Tulip and Text
          Box. Rally Navigator utilizes full library of FIA Navigational Icons.
          Pro Users can add Custom Icons.
        </li>
        <li>
          Right Click in a box to Add Text Descriptions with turn info and
          navigational hints to each Waypoint.
        </li>
        <li>Right Click in Text box to Add a Background Image</li>
        <li>
          Continue along Route till you have fine tuned Track and created
          details for each Waypoint.
        </li>
      </ul>
      <h2 class="font-bold text-left">Print and Export</h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          Choose File &gt; Print to PDF for A5, A4, Letter, Legal or a moto
          roll (multi-wide rolls are Pro), with the FIA lexicon pages if you
          need them.
        </li>
        <li>
          Use File &gt; Export for OpenRally GPX, Plain GPX, KML or the TSD
          worksheet.
        </li>
        <li>
          File &gt; Export &gt; Export To Rally Device has ready-made profiles for
          Stella, RallySafe, TerraPirata, Sporttrax, YB Tracking and more.
          <router-link to="/timing-scoring" class="text-[#FF0000] hover:underline"
            >See all integrations</router-link
          >
        </li>
      </ul>
      <picture class="contents">
        <source srcset="/images/create-cross-country/CC-Screen-Shot-3.webp" type="image/webp" />
        <img
          decoding="async"
          loading="lazy"
          width="1917"
          height="1029"
          src="/images/create-cross-country/CC-Screen-Shot-3.jpg"
          class="flex m-auto"
          alt="Cross-country rally roadbook with tulip diagrams and FIA navigation icons"
          sizes="(max-width: 1917px) 100vw, 1917px"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-bold">Pre-Running and Route Checking</h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>
          <strong
            >Once the Route is initially done. Its time to physically pre-run
            and check the Route and make any corrections prior to investing time
            drawing detailed Tulips.</strong
          >
        </li>
        <li>
          <strong
            >While checking route, capture a GPX Track of the Pre-Run to help
            with final Route editing</strong
          >
        </li>
        <li>
          <strong
            >While pre-running, check distance, headings, etc. at every
            Waypoint. Mark all Landmark and Terrain details. This can be done
            with a GPS, voice recorder or note pad.</strong
          >
        </li>
        <li>
          <strong>Pre-Run With the GPS Roadbook Validator (Pro).</strong> Load
          your roadbook, plug in a USB GPS and choose File &gt; GPS Roadbook
          Validator. The roadbook follows you as you drive &#8211; fix waypoints on
          the spot, and tap Space to add a new one where you are.
          <router-link
            to="/pro-features#gps-validator"
            class="text-[#FF0000] hover:underline"
            >See how it works</router-link
          >
        </li>
        <li>
          <strong>Or Record It Live (Pro).</strong> File &gt; GPS Roadbook
          Recorder builds the roadbook as you drive the route.
          <router-link
            to="/pro-features#gps-recorder"
            class="text-[#FF0000] hover:underline"
            >See how it works</router-link
          >
        </li>
      </ul>
      <h2 class="font-bold">Finalizing the Route After the Pre-Run</h2>
      <ul
        class="list-disc pl-8 text-left py-2 flex flex-col gap-2 font-arial text-[14px] text-[#A9A9A9]"
      >
        <li>Overlay GPX File of the Pre-Run</li>
        <li>
          <strong
            >Review the Overlay GPX Track and your route notes to make any
            necessary changes/corrections to Route.</strong
          >
        </li>
        <li>
          <strong
            >Add final detailed tulips, Icons and Waypoint Descriptions.</strong
          >
        </li>
        <li>You are Ready to Rock</li>
      </ul>
      <ADVRider />
    </div>
    <GuideDownloadCta />
  </section>
  <section class="my-8 mx-auto max-w-[1400px]">
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload />
  </section>
  <RelatedGuides
    :links="[
        { to: '/how-to-create-a-road-rally', text: 'How to Create a Road Rally Roadbook' },
        { to: '/rally-maps', text: 'Rally Route Planner' },
        { to: '/rally-tulip-diagrams', text: 'Rally Tulip Diagrams' },
        { to: '/fim-fia-roadbook-specs-rules', text: 'FIM/FIA Roadbook Specs' },
        { to: '/rally-roadbook', text: 'Roadbook Creator: What Is a Rally Roadbook?' },
      ]"
  />
</template>

<script>
import YouTubeEmbed from './YouTubeEmbed.vue';
import FeaturesBanner from './FeaturesBanner.vue';
import RelatedGuides from './RelatedGuides.vue';
import GuideDownloadCta from './GuideDownloadCta.vue';
import SampleRoadbookIntro from './SampleRoadbookIntro.vue';
import { trackSampleDownload } from '../analytics';
import EventsBanner from './EventsBanner.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import ADVRider from './ADVRider.vue';

export default {
  name: 'CreateCrossCountry',
  components: {
    YouTubeEmbed,
    GuideDownloadCta,
    SampleRoadbookIntro,
    FeaturesBanner,
    RelatedGuides,
    RallyLogoDownload,
    PartnersSmall,
    EventsBanner,
    ADVRider,
  },
  data() {
    return {
      eventsBannerImages: [],
    };
  },
  mounted() {
    fetch('/BannerImagesLists/CrossCountryBannerImageList.json')
      .then((response) => response.json())
      .then((data) => {
        this.eventsBannerImages = data.sort(() => Math.random() - 0.5);
      });
  },
  methods: {
    onSampleClick(event) {
      trackSampleDownload(event);
    },
  },
};
</script>

<style scoped></style>
